import { Project } from './types';

export const transformProject = (data: any): Project => {
  return {
    id: data.id || null,
    name: data.name || null,
    customerId: data.customerId || null,
    customer: data.customer || null,
    accountingClass: data.accountingClass || null,
    accountingClassId: data.accountingClassId || null,
    accountingId: data.accountingId || null,
    startDate: data.startDate || null,
    endDate: data.endDate || null,
    datecreated: data.datecreated || null,
    datemodified: data.datemodified || null,
    notes: data.notes || null,
    dateDeleted: data.dateDeleted || null,
    deleted: data.deleted || false,
  };
};

export const transformToRequestProject = (project: Project): any => {
  return {
    id: project.id,
    name: project.name,
    customerId: project.customerId,
    accountingClassId: project.accountingClassId,
    accountingId: project.accountingId,
    startDate: project.startDate,
    endDate: project.endDate,
    notes: project.notes,
  };
};
